import { render, staticRenderFns } from "./user-password-creation.vue?vue&type=template&id=c743473e&scoped=true"
import script from "./user-password-creation.vue?vue&type=script&lang=js"
export * from "./user-password-creation.vue?vue&type=script&lang=js"
import style0 from "./user-password-creation.vue?vue&type=style&index=0&id=c743473e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c743473e",
  null
  
)

export default component.exports